module.exports = __webpack_public_path__ + "static/media/background-light.7e0f7760.jpg";